<div class="add_new_md">
    
    <form [formGroup]="addStatusNotesForm" (ngSubmit)="addStatusNotes()">
       <div class="add-header">
        <div class="md-header">
            <div class="row">
                <div class="col-sm-6">
                    De-activate
                </div>
                <div class="col-sm-3">
                    
                </div>
                <div class="col-sm-3" style="text-align: right;margin-top: -5px;">
                    <button type="button" class="cenl_btn" (click)="closePopup()"><span class="material-icons cenl_btn_icon ">
                        close
                        </span></button>
                </div>
            </div>
        </div>
       </div>
           
        
        <div class="add_scroll">
            <div class="ad_ox">
               
               
               
              <br>
         
                
                <div class="form-group">
                    <label for="Description">Notes*</label>
                    <textarea rows="4" cols="50" id="Notes" autocomplete="off" formControlName="statusNotes" placeholder="Enter status notes"></textarea>
                </div>
                <!-- <strong *ngIf="addDiscountForm.get('description').invalid && addDiscountForm.get('description').touched" style="color: 'red'; font-size: small">Field is manadatory</strong> -->
            </div>
        </div>

        <div class="add_footer">
            <div class="md-footer">
                <div class="row">
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-4" style="
                    text-align: right;
                ">
                        <button type="button" class="footer_button_cancel" (click)="closePopup()">Cancel</button>
                    </div>
                    <div class="col-sm-4" style="
                    text-align: right;
                ">
                        <button type="submit" class="footer_button" [disabled]="addStatusNotesForm.invalid">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
